<script setup>
import PrimaryButton from "../../../../frontend/src/components/ui/PrimaryButton.vue";
import {reactive, ref} from "vue";
import useForm from "@/composables/useForm";
import aiPromptsService from "@/services/ai-prompts.service";

const emit = defineEmits(['saved']);

const form = reactive({
    name: null,
    description: null,
    text: null,
})

const {populateForm, resetForm} = useForm(form);
const showModal = ref(false);
const id = ref(null);
const loading = ref(false);

async function getData() {
    const {data} = await aiPromptsService.getEdit(id.value);
    populateForm(data);
}

async function save() {
    loading.value = true;

    try {
        await aiPromptsService.save(id.value, form);
        showModal.value = false;
        emit('saved');
    } finally {
        loading.value = false;
    }
}

function open(itemId) {
    resetForm();
    id.value = itemId;
    showModal.value = true;
    getData();
}

defineExpose({open});
</script>

<template>
    <b-modal
        v-model="showModal"
        modal-class="modal-w-md" :title="(id ? 'Edit' : 'Add') + ' Prompt'"
    >
        <form class="form pb-5">
            <div class="form__item">
                <h5 class="heading5 heading5--secondary">Description</h5>
                <input class="form-control--mid form-control" type="text" v-model="form.description">
            </div>

            <div class="form__item">
                <h5 class="heading5 heading5--secondary">Text</h5>

                <textarea
                    v-model="form.text"
                    rows="10"
                    class="form-control"
                />
            </div>
        </form>

        <template #modal-footer>
            <PrimaryButton
                :loading="loading"
                @click="save"
            />
        </template>
    </b-modal>
</template>

<style scoped>

</style>
